// TODO: Заменить Record<string, string | undefined> на какой-то точный тип.
export default (a: Record<string, string | undefined> = {}) => {
  // replace нужен тк улица имеет сокращение с двумя точками 'ул..'
  const streetKind = a.streetKind?.replace('..', '.') ?? '';

  return [
    a.postalCode ? a.postalCode : '',
    a.cityName ? a.cityName : '',
    a.streetName ? `${streetKind} ${a.streetName}` : '',
    a.house ? `д. ${a.house}` : '',
    a.houseBlock ? `корпус ${a.houseBlock}` : '',
    a.building ? `строение ${a.building}` : '',
    a.entrance ? `подъезд ${a.entrance}` : '',
    a.apartment ? `кв. ${a.apartment}` : '',
    a.floor ? `этаж ${a.floor}` : '',
    a.metroStationName ? `метро ${a.metroStationName}` : '',
  ].filter((t) => !!t).join(', ');
};
